/* global axios */
import ApiClient from './ApiClient';

class PermutasAPI extends ApiClient {
  constructor() {
    super('permutas', { accountScoped: true });
  }

  setStatus({ source, code, status }) {
    return axios.post(`${this.url}/set_status`, { source, code, status });
  }

  openConversation({ phone, name, code, source }) {
    return axios.post(`${this.url}/open_conversation`, {
      phone,
      name,
      code,
      source,
    });
  }

  lookup(code) {
    return axios.get(`${this.url}/lookup`, { params: { code } });
  }

  searchContacts(q) {
    return axios.get(`${this.url}/search_contacts`, { params: { q } });
  }
}

export default new PermutasAPI();
